import { render, staticRenderFns } from "./BusinessChangeLog.vue?vue&type=template&id=92dd7602&"
import script from "./BusinessChangeLog.vue?vue&type=script&lang=js&"
export * from "./BusinessChangeLog.vue?vue&type=script&lang=js&"
import style0 from "./BusinessChangeLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports